import axiosConfig from "../../../utils/axiosConfig";

const baseUrl = "pages/sales_revenue/discounts_chart";

export const api = {
  getValues(params) {
    return axiosConfig.post(`${baseUrl}`, params);
  },
  getFilters(params) {
    return axiosConfig.post(`${baseUrl}/get_filters`, params);
  }
};
